import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { KycService } from '@app/core/kyc.service';
import { Injectable } from '@angular/core';

@Injectable()
export class CoverageRouteGuard implements CanActivate {

    constructor(private kycService: KycService, private router: Router) {
    }
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        const isCoverageCompleted = this.kycService.kyc.coverage.completed;
      if (!isCoverageCompleted) {
            let tenant = this.kycService.getTenant();
            this.router.navigate([tenant, 'journey', 'profile']);
            return false;
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/route-guard/coverage-route-guard.ts